import React, { Suspense, lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
// import Main from './Pages/Main';
// import { NotFound } from './Pages';
import LoadingPage from './Pages/MainPage/LoadingPage';
import errorBoundary from './Pages/MainPage/RefreshPage';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';

const Main = lazy(() => import('./Pages/Main'));
const PolicyRouter = lazy(() => import('./Components/invoice/PolicyRouter'));
const ServiceRouter = lazy(() => import('./Components/invoice/ServiceRouter'));
const MainRouter = lazy(() => import('./Components/invoice/MainRouter'));

const NotFound = lazy(() => import('./Pages/NotFound/NotFound'));

const AppRouter = (props) => {
  return (
    <ErrorBoundary FallbackComponent={errorBoundary}>
      <Suspense fallback={<LoadingPage />}>
        <Switch>
          <Redirect exact from='/' to='/main' />
          <PublicRoute restricted={true} exact path='/main' component={Main} />
          <PublicRoute path='/policy' component={PolicyRouter} />
          <PublicRoute path='/account' component={MainRouter} />
          <PublicRoute path='/introduction' component={ServiceRouter} />
          <PublicRoute path='/support' component={ServiceRouter} />

          <PrivateRoute path='/issuance' component={ServiceRouter} />
          <PrivateRoute path='/inquiry' component={ServiceRouter} />
          <PrivateRoute path='/poscrm' component={ServiceRouter} />
          <PrivateRoute path='/statistics' component={ServiceRouter} />
          <PrivateRoute path='/poscrmstatistics' component={ServiceRouter} />
          <PrivateRoute path='/management' component={ServiceRouter} />
          <PrivateRoute path='/company' component={MainRouter} />
          <Route path='/*' component={NotFound} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  );
};

export default AppRouter;
